export default __webpack_public_path__ + "static/media/metroMarker.bc459c78.svg";